<template>
  <div>
    <!-- Header -->
    <div class="header bg-default py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">OANDA LATAM</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <b-card no-body class="bg-secondary border-0 mb-0">
            <b-card-body class="px-lg-5 py-lg-5">

              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              name="Email"
                              :rules="{required: true, email: true}"
                              prepend-icon="ni ni-email-83"
                              placeholder="Email"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              prepend-icon="ni ni-lock-circle-open"
                              type="password"
                              placeholder="Password"
                              v-model="model.password">
                  </base-input>
                  <div class="text-center">
                    <base-button type="primary" native-type="submit" class="my-4 btn-block">INICIAR SESION</base-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import {post} from "@/util/axiosRequest";
import {encrypt} from "@/util/encrypt";

export default {
  data() {
    return {
      model: {
        email: '',
        password: '',
        rememberMe: false
      }
    };
  },
  mounted() {
    localStorage.removeItem('oanda-type-admin-am')
    localStorage.clear()
  },
  methods: {
    onSubmit() {
      post("auth/login", {email: this.model.email, password: this.model.password}, false).then(({data}) => {
        if (data.statusCode === 200) {
          const encr = data.role
          localStorage.setItem('oanda-user-admin-am', JSON.stringify({name: data.name, uid: data.uid}))
          this.$store.commit("setUser", {name: data.name, uid: data.uid})
          localStorage.setItem('oanda-type-admin-am', encr)
          localStorage.setItem('oanda-token-admin-am', data.token)
          this.$router.push({name: 'user-list'})
        }
      })
    }
  }
};
</script>
